import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import withDataContext from 'components/withDataContext';
import { PERMISSIONS, DATA_PERMISSIONS } from 'contexts/PermissionsContext';
import { ApAuthenticationContextConsumer } from '@alixpartners/ui-utils';

import SettingsSubnav from './SettingsSubnav';
import UnpublishedControl from './UnpublishedControl';
import { Notifications } from './Notifications';
import { UPLOAD_STATUS } from 'Data/constants';
import { Wrapper, Divider } from './styles';
import {
	ApButtonTab,
	ApButtonIconWrapper,
	ApMenuUser,
	ApMenuItem,
} from '@alixpartners/ui-components';
import get from 'lodash/get';

const getInitials = fullName => {
	return fullName
		.split(' ')
		.map(n => n[0])
		.join('');
};

class NavBase extends React.Component {
	static propTypes = {
		disabled: PropTypes.bool,
	};

	static defaultProps = {
		disabled: false,
	};

	state = {
		currentBookmark: 0,
		bookmarks: [],
	};

	componentWillReceiveProps({ location }) {
		const { state: locationState = {} } = location;

		if (locationState) {
			const hasBookmarks =
				locationState.bookmarks &&
				locationState.bookmarks !== this.state.bookmarks;

			const hasBookmarkIndex =
				locationState.hasOwnProperty('currentIndex') &&
				locationState.currentIndex !== this.state.currentBookmark;

			if (hasBookmarks) {
				this.setState({ bookmarks: locationState.bookmarks });
			}

			if (hasBookmarkIndex) {
				this.setState({ currentBookmark: locationState.currentIndex });
			}
		} else {
			this.setState({ currentBookmark: 0, bookmarks: [] });
		}
	}

	getActiveClassName = path => {
		const { location } = this.props;

		return location.pathname.indexOf(path) === 0 ? 'active' : '';
	};

	render() {
		const {
			permissions,
			location,
			status,
			config,
			logout,
			user,
			isPortco,
		} = this.props;
		// const { currentBookmark, bookmarks } = this.state;
		// const showNavBookmarks = bookmarks && bookmarks.length > 0;
		const noData = !status.isDataPublished;
		const forceSettings =
			(status.state === UPLOAD_STATUS.CLASSIFIED &&
				!status.isUnpublishedDataExists) ||
			(config &&
				config.isAlreadyExists &&
				permissions.includes(PERMISSIONS.SettingsClassificationWrite) &&
				status.state === UPLOAD_STATUS.NO_DATA);
		const showDataLink = DATA_PERMISSIONS.some(i => permissions.includes(i));
		const isTaxonomyPermission = permissions.includes(
			PERMISSIONS.TaxonomyApply
		);
		return (
			<Wrapper>
				{showDataLink && (
					<NavLink
						to="/data"
						title="Data"
						className={this.getActiveClassName('/data')}
					>
						<ApButtonTab
							theme="dark"
							isSelected={location.pathname.includes('/data')}
							style={{ fontSize: '15px', padding: '0px 6px' }}
						>
							Data
						</ApButtonTab>
					</NavLink>
				)}
				{isTaxonomyPermission && (
					<NavLink
						to="/taxonomymapper/direct"
						title="Taxonomy Mapper"
						className={this.getActiveClassName('/taxonomymapper')}
					>
						<ApButtonTab
							theme="dark"
							isSelected={location.pathname.indexOf('/taxonomymapper') === 0}
							style={{ fontSize: '15px', padding: '0px 6px' }}
						>
							Taxonomy Mapper
						</ApButtonTab>
					</NavLink>
				)}

				<NavLink
					to="/spend"
					title="Analysis"
					className={this.getActiveClassName('/spend')}
				>
					<ApButtonTab
						theme="dark"
						isSelected={location.pathname.indexOf('/spend') === 0}
						style={{ fontSize: '15px', padding: '0px 6px' }}
					>
						Analysis
					</ApButtonTab>
				</NavLink>
				<NavLink
					to="/initiatives/categories"
					title="Initiatives/Categories"
					className={this.getActiveClassName('/initiatives')}
				>
					<ApButtonTab
						theme="dark"
						isSelected={location.pathname.indexOf('/initiatives') === 0}
						style={{ fontSize: '15px', padding: '0px 6px' }}
					>
						Initiatives
					</ApButtonTab>
				</NavLink>
				<NavLink
					to="/waves"
					title="Waves"
					className={this.getActiveClassName('/waves')}
				>
					<ApButtonTab
						theme="dark"
						isSelected={location.pathname.indexOf('/waves') === 0}
						style={{ fontSize: '15px', padding: '0px 6px' }}
					>
						Wave Planning
					</ApButtonTab>
				</NavLink>
				<NavLink
					to="/budget"
					title="Budget Tracker"
					className={this.getActiveClassName('/budget')}
				>
					<ApButtonTab
						theme="dark"
						isSelected={location.pathname.indexOf('/budget') === 0}
						style={{ fontSize: '15px', padding: '0px 6px' }}
					>
						Savings Tracker
					</ApButtonTab>
				</NavLink>
				{!isPortco && (
					<NavLink
						to="/category-management"
						title="Category Management"
						className={this.getActiveClassName('/category-management')}
					>
						<ApButtonTab
							theme="dark"
							isSelected={
								location.pathname.indexOf('/category-management') === 0
							}
							style={{ fontSize: '15px', padding: '0px 6px' }}
						>
							Category Management
						</ApButtonTab>
					</NavLink>
				)}
				<Divider />
				<ApButtonIconWrapper theme="dark">
					<Notifications />
				</ApButtonIconWrapper>
				{permissions.includes(PERMISSIONS.UnpublishedDataRead) && (
					<UnpublishedControl
						isActive={location.pathname.indexOf('/unpublished') === 0}
					/>
				)}
				<SettingsSubnav
					permissions={permissions}
					noData={noData}
					forceSettings={forceSettings}
					config={config}
				/>
				<ApMenuUser
					initials={user ? getInitials(get(user, 'profile.name')) : ''}
				>
					{logout && <ApMenuItem onClick={logout}>Logout</ApMenuItem>}
				</ApMenuUser>
			</Wrapper>
		);
	}
}

export const Nav = withDataContext(NavBase);

export default props => (
	<ApAuthenticationContextConsumer>
		{({ user, logout }) => <Nav user={user} logout={logout} {...props} />}
	</ApAuthenticationContextConsumer>
);
